<template>
    <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M1 1L23 23" />
        <path d="M16.72 11.0601C17.5391 11.4598 18.305 11.9604 19 12.5501" />
        <path d="M5 12.5502C6.48208 11.311 8.26587 10.4864 10.17 10.1602" />
        <path d="M10.71 5.05023C12.8524 4.8776 15.0076 5.13839 17.047 5.81705C19.0864 6.4957 20.9682 7.5783 22.58 9.00023" />
        <path d="M1.42004 9.00012C2.80721 7.77397 4.39774 6.79934 6.12004 6.12012" />
        <path d="M8.53003 16.1102C9.54523 15.389 10.7597 15.0015 12.005 15.0015C13.2504 15.0015 14.4648 15.389 15.48 16.1102" />
        <path d="M12 20H12.01" />
    </g>
</template>
